import type { InboxThread } from "@tellescope/types-models";
import { cn } from "@tellescope/ui";
import { Mail, MessageCircle, Smartphone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getZendeskSrc } from "../../../../utils";

export interface ChannelIconProps {
  channel: InboxThread["type"];
  className?: string;
}

export const ChannelIcon = ({ channel, className }: ChannelIconProps) => {
  const location = useLocation();

  switch (channel) {
    case "Chat":
      return <MessageCircle className={cn("h-3 w-3 text-muted-foreground", className)} />;
    case "Email":
      return <Mail className={cn("h-3 w-3 text-muted-foreground", className)} />;
    case "SMS":
      return <Smartphone className={cn("h-3 w-3 text-muted-foreground", className)} />;
    case "Zendesk":
      return <img src={getZendeskSrc(location)} className={cn("h-2.5 w-2.5 opacity-50", className)} />;
    default:
      return <MessageCircle className={cn("h-3 w-3 text-muted-foreground", className)} />;
  }
};
